import { render, staticRenderFns } from "./OrderedItem.vue?vue&type=template&id=5d449d18"
import script from "./OrderedItem.vue?vue&type=script&lang=js"
export * from "./OrderedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports